import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { ReservationSearchItem } from 'src/app/model/reservation-search-item';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { ReservationRescheduleWizardService } from 'src/app/services/wizard/reservation/reservation-reschedule.wizard.service';
import { ReservationService } from 'src/app/services/reservation.service';
// tslint:disable-next-line:max-line-length
import { DialogCancelMedicalAppointmentComponent } from '../../dialogs/medical-appointment-cancel/dialog-medical-appointment-cancel.component';
import { MedicalAppointmentCancel } from 'src/app/model/medical-appointment-cancel';
// tslint:disable-next-line:max-line-length
import { MedicalAppointmenObservationDialogComponent } from '../../dialogs/medical-appointment-observation/medical-appointment-observation-dialog.component';
import { OtherMedicalAppointmenDialogComponent } from '../../dialogs/other-medical-appointment/other-medical-appointment-dialog.component';
import { PatientViewDialogComponent } from '../../dialogs/patient-view/patient-view-dialog.component';
// tslint:disable-next-line:max-line-length
import { ChangeEquipmentPhysicianDialogComponent } from '../../dialogs/change-equipment-physician/change-equipment-physician-dialog.component';
import { Reservation } from 'src/app/model/reservation';
import { MedicalAppointmenConfirmationDialogComponent } from '../../dialogs/medical-appointment-confirmation/medical-appointment-confirmation-dialog.component';

@Component({
    selector: 'app-reservation-confirmation',
    templateUrl: './reservation-confirmation.component.html',
    styleUrls: ['./reservation-confirmation.component.css'],
  })
  export class ReservationConfirmationComponent implements OnInit, OnDestroy {

    private readonly sessionColumnsKey = 'reservation-confirmation.columns.v1';
    private readonly sessionSortKey = 'reservation-confirmation.sort';
    private readonly sessionColumnWidthsKey = 'reservation-confirmation.column-widths.v1';
    private hasStoredColumnsState = false;

    displayedColumns: string[] = [
      'select', 'DateTime', 'Document', 'Year', 'StateName',
      'PatientLasNameFirstName', 'PersonalPhone', 'LaboralPhone', 'CellPhone', 'PrincipalPracticeName',
      'ConfirmationStateName', 'ConfirmationAccept', 'star'
    ];

    readonly columnsDefinition: Array<{ field: string; title: string }> = [
      { field: 'DateTime', title: 'Fecha' },
      { field: 'PatientLasNameFirstName', title: 'Paciente' },
      { field: 'Document', title: 'Documento' },
      { field: 'Year', title: 'Edad' },
      { field: 'StateName', title: 'Estado' },
      { field: 'ConfirmationStateName', title: 'Estado confir.' },
      { field: 'ConfirmationAccept', title: 'Acepta confir.' },
      { field: 'PersonalPhone', title: 'Tel. part.' },
      { field: 'LaboralPhone', title: 'Tel. lab.' },
      { field: 'CellPhone', title: 'Tel. cel.' },
      { field: 'PrincipalPracticeName', title: 'Práctica' },
    ];

    loadingAction: boolean;
    searchFilters: SearchFilter[];
    draggedColumn: string | null = null;
    sortActive: string = '';
    sortDirection: string = '';
    allItems: ReservationSearchItem[] = [];
    columnFilters: { [key: string]: string } = {};
    columnWidths: { [key: string]: number } = {};
    dataSource: ReservationSearchItem[] = [];
    selection = new SelectionModel<ReservationSearchItem>(true, []);

    @ViewChild('searchFilter', { static: false }) searchFilter: SearchFilterComponent;
    @ViewChild('pager', { static: true }) pager: PagerControlComponent;

    constructor(public dialog: MatDialog
      , private router: Router
      , private menuService: MenuService
      , private confirmDialogService: ConfirmDialogService
      , private notificationToastService: NotificationToastService
      , private reservationRescheduleWizardService: ReservationRescheduleWizardService
      , private reservationService: ReservationService) {
      this.menuService.setMenuTitle('Turnos', 'confirmación');
    }

    get isAnySelected(): boolean { return this.selection.selected.length > 0; }

    ngOnInit(): void {
      this.restoreColumnsOrder();
      this.normalizeDisplayedColumns();
      this.restoreSortState();
      this.restoreColumnWidths();
    }

    ngOnDestroy() {
      this.removeResizeListeners();
    }

    onStartSearch() {}

    isAllSelected() {
      if (this.selection.selected && this.pager.getAllItems()) {
        return this.selection.selected.length === this.pager.getAllItems().length;
      }
      return false;
    }

    masterToggle() {
      this.isAllSelected()
        ? this.selection.clear()
        : this.pager.getAllItems().forEach(row => this.selection.select(row));
    }

    private getSelectedMedicalAppointmentIds(): number[] {
      const medicalAppointmentIds: number[] = [];
      this.selection.selected.forEach((item) => {
        medicalAppointmentIds.push(item.MedicalAppointmentId);
      });
      return medicalAppointmentIds;
    }

    setConfirm(): void {
        this.setMedicalAppointmentConfirmation(this.getSelectedMedicalAppointmentIds(), 1);
    }

    setNoReponse(): void {
        this.setMedicalAppointmentConfirmation(this.getSelectedMedicalAppointmentIds(), 2);
    }

    setReview(): void {
        this.setMedicalAppointmentConfirmation(this.getSelectedMedicalAppointmentIds(), 3);
    }

    viewHistory(reservationSearchItem: ReservationSearchItem): void {
        const medicalAppointmentIds = [];
        medicalAppointmentIds.push(reservationSearchItem.MedicalAppointmentId);
        this.setMedicalAppointmentConfirmation(medicalAppointmentIds);
    }

    setMedicalAppointmentConfirmation(medicalAppointmentIds: number[], confirmationStatusId?: number): void {
        if (medicalAppointmentIds.length > 0) {
            const dialogRef = this.dialog.open(MedicalAppointmenConfirmationDialogComponent, {
                width: '50%',
                data: { medicalAppointmentIds: medicalAppointmentIds
                        , confirmationStatusId: confirmationStatusId
                      }
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this.selection.clear();
                    this.searchFilter.search();
                }
            });
        }
    }

    async rollBack() {
        const medicalAppointmentIds = this.getSelectedMedicalAppointmentIds();

        if (medicalAppointmentIds.length > 0) {
          try {
            this.loadingAction = true;
            await this.reservationService.medicalAppointmentConfirmationRollBack(medicalAppointmentIds);
            this.selection.clear();
            await this.searchFilter.search();
          } catch (err) {
            this.notificationToastService.error(JSON.stringify(err.error), 'Confirmación de turnos');
          } finally {
            this.loadingAction = false;
          }
        }
    }

    openMedicalAppointmentCancelDialog(): void {
        const medicalAppointmentIds = this.getSelectedMedicalAppointmentIds();
        if (medicalAppointmentIds.length > 0) {
            const dialogRef = this.dialog.open(DialogCancelMedicalAppointmentComponent, {
                width: '50%',
                data: { medicalAppointmentIds: medicalAppointmentIds }
            });
            dialogRef.afterClosed().subscribe((result: MedicalAppointmentCancel) => {
                if (result) {
                    this.selection.clear();
                    this.searchFilter.search();
                }
            });
        }
    }

    openMedicalAppointmentObservationDialog(reservationSearchItem: ReservationSearchItem): void {
      const dialogRef = this.dialog.open(MedicalAppointmenObservationDialogComponent, {
        width: '50%',
        data: { medicalAppointmentId: reservationSearchItem.MedicalAppointmentId }
      });
    }

    openOtherMedicalAppointmentDialogDialog(reservationSearchItem: ReservationSearchItem): void {
      const dialogRef = this.dialog.open(OtherMedicalAppointmenDialogComponent, {
        width: '50%',
        data: {
          medicalAppointmentId: reservationSearchItem.MedicalAppointmentId
          , sameCenter: false
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.selection.clear();
          this.searchFilter.search();
        }
      });
    }

    openPatientViewDialog(reservationSearchItem: ReservationSearchItem): void {
      const dialogRef = this.dialog.open(PatientViewDialogComponent, {
        width: '70%',
        data: { patientId: reservationSearchItem.PatientId }
      });
    }

    goReminder(reservationSearchItem: ReservationSearchItem) {
      this.router.navigate(['reminder', reservationSearchItem.MedicalAppointmentId]);
    }

    selectedPageIndexChange(pagedItems: any[]) {
      this.dataSource = pagedItems ? [...pagedItems] : [];
    }

    onEndSearch(response: IFilterResponse<ReservationSearchItem>) {
      this.searchFilters = response && response.searchFilters ? response.searchFilters : [];
      this.selection = new SelectionModel<ReservationSearchItem>(true, []);
      this.allItems = response && response.items ? [...response.items] : [];
      this.refreshGrid();
    }

    async reservationRescheduling(reservationSearchItem: ReservationSearchItem) {
      try {
        this.loadingAction = true;
        const medicalAppointmentIds: number[] = [];
        medicalAppointmentIds.push(reservationSearchItem.MedicalAppointmentId);
        const reservation = await this.reservationService.getRescheduleReservation(medicalAppointmentIds);
        this.reservationRescheduleWizardService.setReservationAndStartWizard(
          new Reservation(reservation), 'reservation-inconsistent');
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Confirmación de turnos');
      } finally {
        this.loadingAction = false;
      }
    }

    goMedicalOrderScann(reservationSearchItem: ReservationSearchItem) {
      this.router.navigate(['medical-order-scann', reservationSearchItem.OrderId]);
    }

    applyFilter(filterValue: string) {}

    get availableColumns(): Array<{ field: string; title: string }> {
      return this.columnsDefinition;
    }

    get orderedColumnsDefinition(): Array<{ field: string; title: string }> {
      const order = this.displayedColumns.filter(col => col !== 'select' && col !== 'star');
      const visibleColumns = new Set(order);
      const orderMap = new Map<string, number>(order.map((col, idx) => [col, idx]));
      return this.columnsDefinition
        .filter(col => visibleColumns.has(col.field))
        .sort((a, b) => {
          const aIdx = orderMap.has(a.field) ? orderMap.get(a.field) : 999;
          const bIdx = orderMap.has(b.field) ? orderMap.get(b.field) : 999;
          return aIdx - bIdx;
        });
    }

    isColumnVisible(column: string): boolean {
      return this.displayedColumns.indexOf(column) >= 0;
    }

    setColumnVisibility(column: string, visible: boolean) {
      const dataColumns = this.displayedColumns.filter(col => col !== 'select' && col !== 'star');
      if (visible) {
        if (dataColumns.indexOf(column) < 0) { dataColumns.push(column); }
      } else {
        if (dataColumns.length <= 1) { return; }
        const idx = dataColumns.indexOf(column);
        if (idx >= 0) { dataColumns.splice(idx, 1); }
        if (this.sortActive === column) {
          this.sortActive = '';
          this.sortDirection = '';
          sessionStorage.removeItem(this.sessionSortKey);
        }
        if (this.columnFilters[column]) { delete this.columnFilters[column]; }
      }
      this.displayedColumns = ['select', ...dataColumns, 'star'];
      this.saveColumnsOrder();
      this.refreshGrid();
    }

    showAllColumns() {
      const allColumns = this.availableColumns.map(col => col.field);
      this.displayedColumns = ['select', ...allColumns, 'star'];
      this.saveColumnsOrder();
      this.refreshGrid();
    }

    sortByColumn(column: string) {
      if (this.sortActive !== column) { this.sortAllData({ active: column, direction: 'asc' }); return; }
      if (this.sortDirection === 'asc') { this.sortAllData({ active: column, direction: 'desc' }); return; }
      this.sortAllData({ active: '', direction: '' });
    }

    getSortIcon(column: string): string {
      if (this.sortActive !== column) { return 'unfold_more'; }
      return this.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward';
    }

    sortAllData(sortEvent: any) {
      if (!sortEvent || !sortEvent.active || sortEvent.direction === '') {
        this.sortActive = ''; this.sortDirection = '';
        sessionStorage.removeItem(this.sessionSortKey);
        this.refreshGrid(); return;
      }
      this.sortActive = sortEvent.active;
      this.sortDirection = sortEvent.direction;
      this.saveSortState();
      this.refreshGrid();
    }

    onColumnFilterInput(column: string, value: string) {
      this.columnFilters[column] = value;
      this.refreshGrid();
    }

    getColumnWidth(column: string): number | null {
      const width = this.columnWidths[column];
      return width && width > 0 ? width : null;
    }

    startResize(event: MouseEvent, column: string) {
      event.preventDefault();
      event.stopPropagation();
      const startX = event.clientX;
      const headerCell = (event.target as HTMLElement).closest('th');
      const measuredWidth = headerCell ? Math.round(headerCell.getBoundingClientRect().width) : 100;
      const startWidth = this.getColumnWidth(column) || Math.max(80, measuredWidth);
      const onMouseMove = (moveEvent: MouseEvent) => {
        const delta = moveEvent.clientX - startX;
        this.columnWidths = { ...this.columnWidths, [column]: Math.max(80, startWidth + delta) };
      };
      const onMouseUp = () => { this.removeResizeListeners(); this.saveColumnWidths(); };
      (window as any).__reservationConfirmationResizeMove = onMouseMove;
      (window as any).__reservationConfirmationResizeUp = onMouseUp;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }

    onHeaderDragStart(event: DragEvent, column: string) {
      this.draggedColumn = column;
      if (event.dataTransfer) { event.dataTransfer.setData('text/plain', column); event.dataTransfer.effectAllowed = 'move'; }
    }

    onHeaderDragOver(event: DragEvent) {
      event.preventDefault();
      if (event.dataTransfer) { event.dataTransfer.dropEffect = 'move'; }
    }

    onHeaderDrop(event: DragEvent, targetColumn: string) {
      event.preventDefault();
      if (!this.draggedColumn || this.draggedColumn === targetColumn) { return; }
      const dataColumns = this.displayedColumns.filter(col => col !== 'select' && col !== 'star');
      const sourceIndex = dataColumns.indexOf(this.draggedColumn);
      const targetIndex = dataColumns.indexOf(targetColumn);
      if (sourceIndex < 0 || targetIndex < 0) { this.draggedColumn = null; return; }
      moveItemInArray(dataColumns, sourceIndex, targetIndex);
      this.displayedColumns = ['select', ...dataColumns, 'star'];
      this.saveColumnsOrder();
      this.draggedColumn = null;
    }

    onHeaderDragEnd() { this.draggedColumn = null; }

    private getSortableValue(item: ReservationSearchItem, property: string): any {
      const value = (item as any)[property];
      if (value === null || value === undefined) { return ''; }
      return typeof value === 'string' ? value.toLocaleLowerCase() : value;
    }

    private saveColumnsOrder() {
      sessionStorage.setItem(this.sessionColumnsKey, JSON.stringify(this.displayedColumns));
    }

    private restoreColumnsOrder() {
      const stored = sessionStorage.getItem(this.sessionColumnsKey);
      if (!stored) { return; }
      try {
        const parsed: string[] = JSON.parse(stored);
        if (!parsed || !Array.isArray(parsed)) { return; }
        const allowed = new Set(this.availableColumns.map(col => col.field));
        const parsedDataColumns = parsed
          .filter(col => col !== 'select' && col !== 'star')
          .filter((col, idx, arr) => arr.indexOf(col) === idx)
          .filter(col => allowed.has(col));
        if (parsedDataColumns.length > 0) {
          this.displayedColumns = ['select', ...parsedDataColumns, 'star'];
          this.hasStoredColumnsState = true;
        }
      } catch { sessionStorage.removeItem(this.sessionColumnsKey); }
    }

    private normalizeDisplayedColumns() {
      const expectedDataColumns = this.availableColumns.map(col => col.field);
      const expectedSet = new Set(expectedDataColumns);
      const currentDataColumns = this.displayedColumns
        .filter(col => col !== 'select' && col !== 'star')
        .filter(col => expectedSet.has(col));
      let normalizedDataColumns = this.hasStoredColumnsState ? [...currentDataColumns] : [...expectedDataColumns];
      if (normalizedDataColumns.length === 0) { normalizedDataColumns = [...expectedDataColumns]; }
      this.displayedColumns = ['select', ...normalizedDataColumns, 'star'];
    }

    private saveSortState() {
      sessionStorage.setItem(this.sessionSortKey, JSON.stringify({ active: this.sortActive, direction: this.sortDirection }));
    }

    private restoreSortState() {
      const stored = sessionStorage.getItem(this.sessionSortKey);
      if (!stored) { return; }
      try {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.active && parsed.direction) { this.sortActive = parsed.active; this.sortDirection = parsed.direction; }
      } catch { sessionStorage.removeItem(this.sessionSortKey); }
    }

    private saveColumnWidths() {
      sessionStorage.setItem(this.sessionColumnWidthsKey, JSON.stringify(this.columnWidths));
    }

    private restoreColumnWidths() {
      const stored = sessionStorage.getItem(this.sessionColumnWidthsKey);
      if (!stored) { this.columnWidths = {}; return; }
      try {
        const parsed = JSON.parse(stored);
        if (!parsed || typeof parsed !== 'object') { return; }
        const validColumns = new Set(this.columnsDefinition.map(col => col.field));
        const restored: { [key: string]: number } = {};
        Object.keys(parsed).forEach(col => {
          if (!validColumns.has(col)) { return; }
          const width = Number(parsed[col]);
          if (!isNaN(width) && width >= 80 && width <= 500) { restored[col] = width; }
        });
        this.columnWidths = restored;
      } catch { sessionStorage.removeItem(this.sessionColumnWidthsKey); this.columnWidths = {}; }
    }

    private refreshGrid() {
      const currentPage = this.pager && this.pager.pager && this.pager.pager.currentPage ? this.pager.pager.currentPage : 1;
      let items = this.applyColumnFilters(this.allItems || []);
      if (this.sortActive && this.sortDirection) { items = this.sortItems([...items], this.sortActive, this.sortDirection); }
      this.pager.setItems(items);
      if (currentPage > 1) { this.pager.setPage(currentPage); }
    }

    private applyColumnFilters(items: ReservationSearchItem[]): ReservationSearchItem[] {
      const filters = Object.keys(this.columnFilters || {}).filter(key => !!this.columnFilters[key] && this.columnFilters[key].trim() !== '');
      if (filters.length === 0) { return [...items]; }
      return items.filter(item =>
        filters.every(column => {
          const filterValue = this.normalizeFilterValue(this.columnFilters[column]);
          const rawVal = (item as any)[column];
          const itemValue = this.normalizeFilterValue(String(rawVal != null ? rawVal : ''));
          return itemValue.indexOf(filterValue) >= 0;
        })
      );
    }

    private sortItems(items: ReservationSearchItem[], active: string, direction: string): ReservationSearchItem[] {
      return items.sort((a, b) => {
        const aValue = this.getSortableValue(a, active);
        const bValue = this.getSortableValue(b, active);
        if (aValue < bValue) { return direction === 'asc' ? -1 : 1; }
        if (aValue > bValue) { return direction === 'asc' ? 1 : -1; }
        return 0;
      });
    }

    private normalizeFilterValue(value: string): string {
      const normalized = value ? String(value) : '';
      return normalized.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    private removeResizeListeners() {
      const onMouseMove = (window as any).__reservationConfirmationResizeMove;
      const onMouseUp = (window as any).__reservationConfirmationResizeUp;
      if (onMouseMove) { document.removeEventListener('mousemove', onMouseMove); (window as any).__reservationConfirmationResizeMove = null; }
      if (onMouseUp) { document.removeEventListener('mouseup', onMouseUp); (window as any).__reservationConfirmationResizeUp = null; }
    }
  }

